export class DownloadSelectionDialog {
    constructor() {
        this.selectionDialog = document.getElementById("pdf-selection");
        document.addEventListener("DOMContentLoaded", () => {
            this.initDialog();
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            if (params.has('selection')) {
                this.showSelection();
                params.delete('selection');
                history.replaceState({}, '', `${location.pathname}?${params}`);
            }
        });

        window.addEventListener('pdfDownloadReady', () => {
            this.activateDownloadButtons();
            this.deactivateLoadIndicator();
        });
    }

    close() {
        this.selectionDialog.close();
        this.closeCustomerDataForm();
        document.body.style.overflow = 'auto';
    }

    showSelection() {
        this.selectionDialog.showModal();
        document.activeElement.blur();
        document.body.style.overflow = 'hidden';
    }

    initDialog() {
        this.selectionDialog.addEventListener('click', (event) => {
            const rect = this.selectionDialog.getBoundingClientRect();
            const isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height
                && rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
            if (!isInDialog) {
                this.close();
            }
        });

        this.populateButtons(this.selectionDialog);
        this.populatePDFSelects(this.selectionDialog);
    }

    populateButtons(dialog) {
        const addToCartButtons = dialog.querySelectorAll('.cta-add-to-cart-type button, .cta-add-to-cart-with-pdf-type button');
        addToCartButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                this.addToCart(e);
            });
        });

        const requestQuoteButtons = dialog.querySelectorAll('.cta-request-quote-type button');
        requestQuoteButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                this.requestQuote(e);
            });
        });

        const downloadPDFButtons = dialog.querySelectorAll('.pdf-select-download-button');
        downloadPDFButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                this.downloadPDF(e);
            });
        });

        const updateDataButton = document.getElementById('pdf-select-customer-data-change');
        if (updateDataButton) {
            updateDataButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.revealCustomerDataForm();
                dialog.querySelector('.pdf-select-customer-data-change').style.display = "none";
            });
        }
    }

    populatePDFSelects(dialog) {
        const pdfSelects = dialog.querySelectorAll('.pdf-type-select');
        pdfSelects.forEach((select) => {
            select.addEventListener('change', (e) => {
                this.closeCustomerDataForm();
                const pdfId = e.target.value;
                const selectedOption = e.target.options[e.target.selectedIndex];
                const customerDataRequired = selectedOption?.getAttribute('data-customer-data-required') ?? false;
                const downloadButton = select.parentElement.querySelector('.pdf-select-download-button');
                downloadButton.setAttribute('data-pdf-id', pdfId);
                downloadButton.setAttribute('data-customer-data-required', customerDataRequired);
            });
        });
    }

    addToCart(e) {
        e.preventDefault();
        let selectedPDFId = "";
        if (e.target.getAttribute('data-pdf-id')) {
            selectedPDFId = e.target.getAttribute('data-pdf-id');
        }
        com.parkside.loader.show(
            () => {
                this.close();
                document.getElementById("action_type").value = "add_to_cart";
                document.getElementById("action").value = "next";
                document.getElementById("user_selected_pdf_type_id").value = selectedPDFId;
                document.forms['price'].submit();
            }
        );
    }

    requestQuote(e) {
        e.preventDefault();
        let cellId = "";
        if (e.target.closest('td').getAttribute('data-cell-id')) {
            cellId = e.target.closest('td').getAttribute('data-cell-id');
        }
        com.parkside.loader.show(() => {
            this.close();
            document.getElementById("action_type").value = "offer";
            document.getElementById("action").value = "next";
            document.getElementById("user_pdf_select_cell_id").value = cellId;
            document.forms['price'].submit();
        }, null);
    }

    revealCustomerDataForm() {
        const customerDataForm = document.getElementById('pdf-select-customer-data');
        customerDataForm.style.display = "";
    }

    closeCustomerDataForm() {
        const customerDataForm = document.getElementById('pdf-select-customer-data');
        customerDataForm.style.display = "none";
        const changeSection = this.selectionDialog.querySelector('.pdf-select-customer-data-change');
        if (changeSection) {
            changeSection.style.display = "block";
        }
    }

    downloadPDF(e) {
        e.preventDefault();
        this.closeCustomerDataForm();
        const pdfId = e.target.getAttribute('data-pdf-id');
        const customerDataRequired = e.target.getAttribute('data-customer-data-required') === 'true';
        const customerDataFilled = e.target.getAttribute('data-customer-data-filled') === 'true';
        if (customerDataRequired && !customerDataFilled) {
            this.revealCustomerDataForm();
            return;
        }
        const downloadURL = e.target.getAttribute('data-url');
        const finalURL = downloadURL.replace('PDF_ID_PLACEHOLDER', pdfId);
        window.location.href = finalURL;
    }

    activateDownloadButtons() {
        const downloadButtons = document.querySelectorAll('.pdf-select-download-button');
        downloadButtons.forEach((button) => {
            button.classList.add('active');
            button.removeAttribute('disabled');
        });
    }

    deactivateLoadIndicator() {
        const loadIndicator = document.getElementById('pdf-select-load-indicator');
        loadIndicator.style.display = "none";
    }
}